const form = `<div id='crmWebToEntityForm' class='zcwf_lblTopBottom crmWebToEntityForm'
style='background-color: white;color: black;max-width: 404px;'>
<meta name='viewport' content='width=device-width, initial-scale=1.0'>
<META HTTP-EQUIV='content-type' CONTENT='text/html;charset=UTF-8'>
<form action='https://crm.zoho.com/crm/WebToLeadForm' name=WebToLeads5813716000000450005 method='POST'
    onSubmit='javascript:document.charset="UTF-8"; return checkMandatory5813716000000450005()'
    accept-charset='UTF-8'>
    <input type='text' style='display:none;' name='xnQsjsdp'
        value='fbd9ac9ef083d47d156e2b601ccf851b002f8770fc457789a46bb8163f949f31'></input>
    <input type='hidden' name='zc_gad' id='zc_gad' value=''></input>
    <input type='text' style='display:none;' name='xmIwtLD'
        value='261ecd957ff9ba152b8b186a9bd4728895298b3fb3b654458c494237be5ca692'></input>
    <input type='text' style='display:none;' name='actionType' value='TGVhZHM='></input>
    <input type='text' style='display:none;' name='returnURL' value='https&#x3a;&#x2f;&#x2f;www.ansoftt.com&#x2f;'>
    </input>
    <!-- Do not remove this code. -->
    <style>
        html,
        body {
            margin: 0px;
        }

        #crmWebToEntityForm.zcwf_lblTopBottom {
            width: 100%;
            padding: 25px;
            margin: 0 auto;
            box-sizing: border-box;
        }

        #crmWebToEntityForm.zcwf_lblTopBottom * {
            box-sizing: border-box;
        }

        #crmWebToEntityForm {
            text-align: left;
        }

        #crmWebToEntityForm * {
            direction: ltr;
        }

        .zcwf_lblTopBottom .zcwf_title {
            word-wrap: break-word;
            padding: 0px 6px 10px;
            font-weight: bold;
        }

        .zcwf_lblTopBottom .zcwf_col_fld input[type=text],
        .zcwf_lblTopBottom .zcwf_col_fld textarea {
            width: 100%;
            height: 40px;
            border: 1px solid #c0c6cc !important;
            resize: vertical;
            border-radius: 2px;
            float: left;
        }

        .zcwf_lblTopBottom .zcwf_col_lab {
            width: 30%;
            word-break: break-word;
            padding: 0px 6px 0px;
            margin-right: 10px;
            margin-top: 5px;
            padding-bottom: 4px;
        }

        .zcwf_lblTopBottom .zcwf_col_fld {
            width: 60%;
            padding: 0px 6px 0px;
            position: relative;
            margin-top: 5px;
        }

        .zcwf_lblTopBottom .zcwf_privacy {
            padding: 6px;
        }

        .zcwf_lblTopBottom .wfrm_fld_dpNn {
            display: none;
        }

        .dIB {
            display: inline-block;
        }

        .zcwf_lblTopBottom .zcwf_col_fld_slt {
            width: 60%;
            border: 1px solid #ccc;
            background: #fff;
            border-radius: 4px;
            font-size: 12px;
            float: left;
            resize: vertical;
            padding: 2px 5px;
        }

        .zcwf_lblTopBottom .zcwf_row:after,
        .zcwf_lblTopBottom .zcwf_col_fld:after {
            content: '';
            display: table;
            clear: both;
        }

        .zcwf_lblTopBottom .zcwf_col_help {
            float: left;
            margin-left: 7px;
            font-size: 12px;
            max-width: 35%;
            word-break: break-word;
        }

        .zcwf_lblTopBottom .zcwf_help_icon {
            cursor: pointer;
            width: 16px;
            height: 16px;
            display: inline-block;
            background: #fff;
            border: 1px solid #c0c6cc;
            color: #c1c1c1;
            text-align: center;
            font-size: 11px;
            line-height: 16px;
            font-weight: bold;
            border-radius: 50%;
        }

        .zcwf_lblTopBottom .zcwf_row {
            margin: 15px 0px;
        }

        .zcwf_lblTopBottom .formsubmit {
            margin-right: 5px;
            cursor: pointer;
            color: var(--baseColor);
            font-size: 12px;
        }

        .zcwf_lblTopBottom .zcwf_privacy_txt {
            width: 90%;
            color: rgb(0, 0, 0);
            font-size: 12px;
            font-family: Arial;
            display: inline-block;
            vertical-align: top;
            color: var(--baseColor);
            padding-top: 2px;
            margin-left: 6px;
        }

        .zcwf_lblTopBottom .zcwf_button {
            font-size: 12px;
            color: var(--baseColor);
            border: 1px solid #c0c6cc;
            padding: 3px 9px;
            border-radius: 4px;
            cursor: pointer;
            max-width: 120px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .zcwf_lblTopBottom .zcwf_tooltip_over {
            position: relative;
        }

        .zcwf_lblTopBottom .zcwf_tooltip_ctn {
            position: absolute;
            background: #dedede;
            padding: 3px 6px;
            top: 3px;
            border-radius: 4px;
            word-break: break-word;
            min-width: 100px;
            max-width: 150px;
            color: var(--baseColor);
            z-index: 100;
        }

        .zcwf_lblTopBottom .zcwf_ckbox {
            float: left;
        }

        .zcwf_lblTopBottom .zcwf_file {
            width: 35%;
            box-sizing: border-box;
            float: left;
        }

        .clearB:after {
            content: '';
            display: block;
            clear: both;
        }

        @media all {

            .zcwf_lblTopBottom .zcwf_col_lab,
            .zcwf_lblTopBottom .zcwf_col_fld {
                width: auto;
                float: none !important;
            }

            .zcwf_lblTopBottom .zcwf_col_help {
                width: 40%;
            }
        }
    </style>
    <div class='zcwf_title' style='max-width: 404px;color: black; font-family:Arial;'>Get in touch</div>
    <div class='zcwf_row'>
        <!-- <div class='zcwf_col_lab' style='font-size:12px; font-family: Arial;'><label for='First_Name'>First
                Name<span style='color:red;'>*</span></label></div> -->
        <div class='zcwf_col_fld'><input type='text' id='First_Name' name='First Name' maxlength='40'
                placeholder='First Name'></input>
            <!-- <div class='zcwf_col_help'> <span title='First Name'
                    style='cursor: pointer; width: 16px; height: 16px; display: inline-block; background: #fff; border: 1px solid #c0c6cc; color: #c1c1c1; text-align: center; font-size: 11px; line-height: 16px; font-weight: bold; border-radius: 50%;'
                    onclick='tooltipShow5813716000000450005(this)'>?</span>
                <div class='zcwf_tooltip_over' style='display: none;'><span class='zcwf_tooltip_ctn'>First
                        Name</span></div>
            </div> -->
        </div>
    </div>
    <div class='zcwf_row'>
        <!-- <div class='zcwf_col_lab' style='font-size:12px; font-family: Arial;'><label for='Last_Name'>Last Name<span
                    style='color:red;'>*</span></label></div> -->
        <div class='zcwf_col_fld'><input type='text' id='Last_Name' name='Last Name' maxlength='80'
                placeholder='Last Name'></input>
            <div class='zcwf_col_help'></div>
        </div>
    </div>
    <div class='zcwf_row'>
        <!-- <div class='zcwf_col_lab' style='font-size:12px; font-family: Arial;'><label for='Email'>Email<span
                    style='color:red;'>*</span></label></div> -->
        <div class='zcwf_col_fld'><input type='text' ftype='email' id='Email' name='Email' maxlength='100'
                placeholder='Email'></input>
            <div class='zcwf_col_help'></div>
        </div>
    </div>
    <div class='zcwf_row'>
        <!-- <div class='zcwf_col_lab' style='font-size:12px; font-family: Arial;'><label for='Mobile'>Mobile<span
                    style='color:red;'>*</span></label></div> -->
        <div class='zcwf_col_fld'><input type='text' id='Mobile' name='Mobile' maxlength='30'
                placeholder='Mobile'></input>
            <div class='zcwf_col_help'></div>
        </div>
    </div>
    <div class='zcwf_row'>
        <!-- <div class='zcwf_col_lab' style='font-size:12px; font-family: Arial;'><label for='Company'>Company<span
                    style='color:red;'>*</span></label></div> -->
        <div class='zcwf_col_fld'><input type='text' id='Company' name='Company' maxlength='200'
                placeholder='Company'></input>
            <div class='zcwf_col_help'></div>
        </div>
    </div>
    <div class='zcwf_row'>
        <!-- <div class='zcwf_col_lab' style='font-size:12px; font-family: Arial;'><label for='Designation'>Title<span
                    style='color:red;'>*</span></label></div> -->
        <div class='zcwf_col_fld'><input type='text' id='Designation' name='Designation' maxlength='100'
                placeholder='Designation'></input>
            <div class='zcwf_col_help'></div>
        </div>
    </div>
    <div class='zcwf_row'>
        <!-- <div class='zcwf_col_lab' style='font-size:12px; font-family: Arial;'><label for='City'>City<span
                    style='color:red;'>*</span></label></div> -->
        <div class='zcwf_col_fld'><input type='text' id='City' name='City' maxlength='100'
                placeholder='City'></input>
            <div class='zcwf_col_help'></div>
        </div>
    </div>
    <div class='zcwf_row'>
    <div class='zcwf_col_lab' style='text-align: center;'></div>
        <div class='zcwf_col_fld' style='text-align: center;'><input type='submit' id='formsubmit' class='formsubmit zcwf_button' value='Submit'
                title='Submit'><input type='reset' class='zcwf_button' name='reset' value='Reset' title='Reset'>
        </div>
    </div>
    <script>
        function validateEmail5813716000000450005() {
            var form = document.forms['WebToLeads5813716000000450005'];
            var emailFld = form.querySelectorAll('[ftype=email]');
            var i;
            for (i = 0; i < emailFld.length; i++) {
                var emailVal = emailFld[i].value;
                if ((emailVal.replace(/^\s+|\s+$/g, '')).length != 0) {
                    var atpos = emailVal.indexOf('@');
                    var dotpos = emailVal.lastIndexOf('.');
                    if (atpos < 1 || dotpos < atpos + 2 || dotpos + 2 >= emailVal.length) {
                        alert('Please enter a valid email address. ');
                        emailFld[i].focus();
                        return false;
                    }
                }
            }
            return true;
        }

        function checkMandatory5813716000000450005() {
            var mndFileds = new Array('Company', 'First Name', 'Last Name', 'Designation', 'Email', 'Mobile', 'City');
            var fldLangVal = new Array('Company', 'First\x20Name', 'Last\x20Name', 'Title', 'Email', 'Mobile', 'City');
            for (i = 0; i < mndFileds.length; i++) {
                var fieldObj = document.forms['WebToLeads5813716000000450005'][mndFileds[i]];
                if (fieldObj) {
                    if (((fieldObj.value).replace(/^\s+|\s+$/g, '')).length == 0) {
                        if (fieldObj.type == 'file') {
                            alert('Please select a file to upload.');
                            fieldObj.focus();
                            return false;
                        }
                        alert(fldLangVal[i] + ' cannot be empty.');
                        fieldObj.focus();
                        return false;
                    } else if (fieldObj.nodeName == 'SELECT') {
                        if (fieldObj.options[fieldObj.selectedIndex].value == '-None-') {
                            alert(fldLangVal[i] + ' cannot be none.');
                            fieldObj.focus();
                            return false;
                        }
                    } else if (fieldObj.type == 'checkbox') {
                        if (fieldObj.checked == false) {
                            alert('Please accept  ' + fldLangVal[i]);
                            fieldObj.focus();
                            return false;
                        }
                    }
                    try {
                        if (fieldObj.name == 'Last Name') {
                            name = fieldObj.value;
                        }
                    } catch (e) { }
                }
            }
            if (!validateEmail5813716000000450005()) { return false; }
            document.querySelector('.crmWebToEntityForm .formsubmit').setAttribute('disabled', true);
        }

        function tooltipShow5813716000000450005(el) {
            var tooltip = el.nextElementSibling;
            var tooltipDisplay = tooltip.style.display;
            if (tooltipDisplay == 'none') {
                var allTooltip = document.getElementsByClassName('zcwf_tooltip_over');
                for (i = 0; i < allTooltip.length; i++) {
                    allTooltip[i].style.display = 'none';
                }
                tooltip.style.display = 'block';
            } else {
                tooltip.style.display = 'none';
            }
        }
    </script>
    <!-- Do not remove this --- Analytics Tracking code starts -->
    <script id='wf_anal'
        src='https://crm.zohopublic.com/crm/WebFormAnalyticsServeServlet?rid=261ecd957ff9ba152b8b186a9bd4728895298b3fb3b654458c494237be5ca692gidfbd9ac9ef083d47d156e2b601ccf851b002f8770fc457789a46bb8163f949f31gid885e3c1045bd9bdcc91bdf30f82b5696gid14f4ec16431e0686150daa43f3210513&tw=61690b96c1d0471b638f31426f38e68aa67fb7ed6da86f32dc10ad817fe55a0a'></script>
    <!-- Do not remove this --- Analytics Tracking code ends. -->
</form>
</div>`;

export default form;